/**
 * Public, keyless model discovery. Shader generation uses Genie's managed API.
 */

import { getJson } from './openai-compatible'
import type { ShaderModelOption } from './openai-compatible'

export const OPENROUTER_API_URL = 'https://openrouter.ai/api/v1'

interface OpenRouterModelsResponse {
  data?: Array<{
    id?: string
    name?: string
    architecture?: { output_modalities?: string[] }
  }>
}

/** Every OpenRouter model that answers in text, from the public (keyless) catalogue. */
export async function listOpenRouterModels(signal?: AbortSignal): Promise<ShaderModelOption[]> {
  const body = await getJson<OpenRouterModelsResponse>({ url: `${OPENROUTER_API_URL}/models`, label: 'OpenRouter' }, signal)
  return (body.data ?? [])
    .filter((model) => {
      const outputs = model.architecture?.output_modalities
      return typeof model.id === 'string' && (!outputs || outputs.includes('text'))
    })
    .map((model) => ({ id: model.id as string, label: model.name || (model.id as string) }))
}
